import Vue from 'vue'

import VueCompositionAPI from '@vue/composition-api'
import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource';
import VueMask from 'v-mask'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import {DateTime} from 'luxon';

Vue.use(VueCompositionAPI)
Vue.use(VueCookie);
Vue.use(VueResource);
Vue.use(VueMask);


Vue.config.productionTip = false

Vue.use({
    install() {
        //Event Bus
        Vue.prototype.$eventHub = new Vue();

        // Loading Spinner
        Vue.prototype.$startLoading = function (timeout) {
            this.$store.commit('startLoading', timeout);
        };
        Vue.prototype.$stopLoading = function () {
            this.$store.commit('stopLoading');
        };
        // Alert Top Bar
        Vue.prototype.$showAlertMessage = function (message, handler, actions = null) {
            this.$eventHub.$emit('showAlertMessage', {message, handler, actions});
        };

        // Helpers
        Vue.prototype.$convertFileToBase64 = async function (file) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });

            return await toBase64(file);
        };

        Vue.prototype.$parseDate = function (d, fmt = 'yyyy-MM-dd HH:mm') {
            return DateTime.fromISO(d).toFormat(fmt);
        };

        Vue.prototype.$tryHandleError = function (response) {
            if (typeof response.body === 'object') {
                if ('msg' in response.body) {
                    let msg = response.body.msg;
                    if (this.$te('error_messages.' + msg)) {
                        this.$showAlertMessage(this.$t(`error_messages.${msg}`));
                        return
                    } else {
                        this.$showAlertMessage(msg);
                        return
                    }
                }
            }
            this.$showAlertMessage(this.$t('error_messages.default'));
            throw response;
        }
    }
})

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')
